/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Address,
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    Contractor,
    ContractorFromJSON,
    ContractorFromJSONTyped,
    ContractorToJSON,
    Document,
    DocumentFromJSON,
    DocumentFromJSONTyped,
    DocumentToJSON,
    Exam,
    ExamFromJSON,
    ExamFromJSONTyped,
    ExamToJSON,
    Failure,
    FailureFromJSON,
    FailureFromJSONTyped,
    FailureToJSON,
    Phone,
    PhoneFromJSON,
    PhoneFromJSONTyped,
    PhoneToJSON,
    User,
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './';

/**
 * 
 * @export
 * @interface Repairman
 */
export interface Repairman {
    /**
     * 
     * @type {string}
     * @memberof Repairman
     */
    familyname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Repairman
     */
    middlename?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Repairman
     */
    forename?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Repairman
     */
    birthPlace?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Repairman
     */
    birthDate?: Date;
    /**
     * 
     * @type {Address}
     * @memberof Repairman
     */
    address?: Address;
    /**
     * 
     * @type {Phone}
     * @memberof Repairman
     */
    phone?: Phone;
    /**
     * 
     * @type {string}
     * @memberof Repairman
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Repairman
     */
    isActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Repairman
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Repairman
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Repairman
     */
    contractorId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Repairman
     */
    createdBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof Repairman
     */
    createdDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof Repairman
     */
    modifiedBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Repairman
     */
    modifiedDate?: Date | null;
    /**
     * 
     * @type {User}
     * @memberof Repairman
     */
    creator?: User;
    /**
     * 
     * @type {User}
     * @memberof Repairman
     */
    modifier?: User;
    /**
     * 
     * @type {User}
     * @memberof Repairman
     */
    user?: User;
    /**
     * 
     * @type {Contractor}
     * @memberof Repairman
     */
    contractor?: Contractor;
    /**
     * 
     * @type {Array<Failure>}
     * @memberof Repairman
     */
    failures?: Array<Failure> | null;
    /**
     * 
     * @type {Array<Document>}
     * @memberof Repairman
     */
    documents?: Array<Document> | null;
    /**
     * 
     * @type {Array<Exam>}
     * @memberof Repairman
     */
    exams?: Array<Exam> | null;
    /**
     * 
     * @type {string}
     * @memberof Repairman
     */
    id?: string;
}

export function RepairmanFromJSON(json: any): Repairman {
    return RepairmanFromJSONTyped(json, false);
}

export function RepairmanFromJSONTyped(json: any, ignoreDiscriminator: boolean): Repairman {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'familyname': !exists(json, 'familyname') ? undefined : json['familyname'],
        'middlename': !exists(json, 'middlename') ? undefined : json['middlename'],
        'forename': !exists(json, 'forename') ? undefined : json['forename'],
        'birthPlace': !exists(json, 'birthPlace') ? undefined : json['birthPlace'],
        'birthDate': !exists(json, 'birthDate') ? undefined : (new Date(json['birthDate'])),
        'address': !exists(json, 'address') ? undefined : AddressFromJSON(json['address']),
        'phone': !exists(json, 'phone') ? undefined : PhoneFromJSON(json['phone']),
        'email': !exists(json, 'email') ? undefined : json['email'],
        'isActive': !exists(json, 'isActive') ? undefined : json['isActive'],
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'contractorId': !exists(json, 'contractorId') ? undefined : json['contractorId'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : json['modifiedBy'],
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'creator': !exists(json, 'creator') ? undefined : UserFromJSON(json['creator']),
        'modifier': !exists(json, 'modifier') ? undefined : UserFromJSON(json['modifier']),
        'user': !exists(json, 'user') ? undefined : UserFromJSON(json['user']),
        'contractor': !exists(json, 'contractor') ? undefined : ContractorFromJSON(json['contractor']),
        'failures': !exists(json, 'failures') ? undefined : (json['failures'] === null ? null : (json['failures'] as Array<any>).map(FailureFromJSON)),
        'documents': !exists(json, 'documents') ? undefined : (json['documents'] === null ? null : (json['documents'] as Array<any>).map(DocumentFromJSON)),
        'exams': !exists(json, 'exams') ? undefined : (json['exams'] === null ? null : (json['exams'] as Array<any>).map(ExamFromJSON)),
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function RepairmanToJSON(value?: Repairman | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'familyname': value.familyname,
        'middlename': value.middlename,
        'forename': value.forename,
        'birthPlace': value.birthPlace,
        'birthDate': value.birthDate === undefined ? undefined : (value.birthDate.toISOString()),
        'address': AddressToJSON(value.address),
        'phone': PhoneToJSON(value.phone),
        'email': value.email,
        'isActive': value.isActive,
        'isDeleted': value.isDeleted,
        'userId': value.userId,
        'contractorId': value.contractorId,
        'createdBy': value.createdBy,
        'createdDate': value.createdDate === undefined ? undefined : (value.createdDate.toISOString()),
        'modifiedBy': value.modifiedBy,
        'modifiedDate': value.modifiedDate === undefined ? undefined : (value.modifiedDate === null ? null : value.modifiedDate.toISOString()),
        'creator': UserToJSON(value.creator),
        'modifier': UserToJSON(value.modifier),
        'user': UserToJSON(value.user),
        'contractor': ContractorToJSON(value.contractor),
        'failures': value.failures === undefined ? undefined : (value.failures === null ? null : (value.failures as Array<any>).map(FailureToJSON)),
        'documents': value.documents === undefined ? undefined : (value.documents === null ? null : (value.documents as Array<any>).map(DocumentToJSON)),
        'exams': value.exams === undefined ? undefined : (value.exams === null ? null : (value.exams as Array<any>).map(ExamToJSON)),
        'id': value.id,
    };
}


